import { inject, Injectable } from '@angular/core';
import { Auth, signInWithEmailAndPassword, signOut, createUserWithEmailAndPassword, User } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthService {

  private apiUrl = `${environment.apiConfig.baseUrl}/auth`;
  private tokenKey = 'accessToken';
  private http = inject(HttpClient);
  private router = inject(Router);
  private auth = inject(Auth);

  login(email: string, password: string): Observable<{ accessToken: string; accessExpires: string }> {
    return this.http.post<{ accessToken: string; accessExpires: string }>(this.apiUrl, { email, password }).pipe(
      tap(response => {
        if (response.accessToken) {
          this.saveToken(response.accessToken);
        }
      })
    );
  }

  getToken(): string | null {
    return localStorage.getItem(this.tokenKey);
  }

  private saveToken(token: string): void {
    localStorage.setItem(this.tokenKey, token);
  }

  isAuthenticated(): boolean {
    return !!this.getToken();
  }


  /*
  async login(email: string, password: string): Promise<void> {
    try {
      await signInWithEmailAndPassword(this.auth, email, password);
      this.router.navigate(['/']);  // Dopo il login, reindirizza alla dashboard
    } catch (error) {
      console.error("Errore di login", error);
    }
  }*/

  async register(email: string, password: string): Promise<void> {
    try {
      await createUserWithEmailAndPassword(this.auth, email, password);
      this.router.navigate(['/']);
    } catch (error) {
      console.error("Errore di registrazione", error);
    }
  }

  async logout(): Promise<void> {
    await signOut(this.auth);
    this.router.navigate(['/auth/login']);
  }

  isLoggedIn(): boolean {
    return !!this.auth.currentUser;
  }
}
